import { store } from './storeInstance';
export default store;
export { store };